import React, { useEffect, useState, useContext } from "react";
import {
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import {
  InputGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import RightSideContent2 from "./RightSideContent2";
import Section2 from "./Section2";
import visaLogo from "../../assets/images/visa-logo.png";
import mastercardLogo from "../../assets/images/mastercard-logo.png"; // Add these images
import discoverLogo from "../../assets/images/yellofintunafish.png";
import amexLogo from "../../assets/images/yellofintunafish.png";
import {
  Card,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import userImage1 from "../../assets/images/yellofintunafish.png";
import { createOrder } from "../../api/order/orderApi";
import { updateAvailableQuantity } from "../../api/stock/addStockApi";
import { getPlantByUserId } from "../../api/processing plant/plantApi";
import { getCourierByUserId } from "../../api/courier/courierApi";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "./Checkout.css";
import Section from "./Section";
import { AuthContext } from "../../pages/ExtraPages/AuthProvider";
import axios from "axios";
import { getToken } from "firebase/messaging";
import { messaging } from "./firebase-config";
import { onMessage } from "firebase/messaging";
// Placeholder API functions
const addAddressToDatabase = async (address) => {
  console.log("Address saved to database:", address);
  return { success: true };
};

const addPaymentToDatabase = async (payment) => {
  console.log("Payment saved to database:", payment);
  return { success: true };
};

const Checkout = () => {
  const [items, setItems] = useState([]);

  const navigate = useNavigate();
  const [cardType, setCardType] = useState("Visa");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [cardNumber, setCardNumber] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [address, setAddress] = useState(null);
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [newAddress, setNewAddress] = useState({ line1: "", line2: "" });
  const [newPayment, setNewPayment] = useState({
    cardNumber: "",
    expiryDate: "",
    cvv: "",
  });
  const [reservationIds, setReservationIds] = useState([]);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [processingPlant, setProcessingPlant] = useState("");

  // Error states for validation
  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    contactNumber: "",
    bill_to_address_state: "",
  });

  // Billing Information State
  const [billingInfo, setBillingInfo] = useState({
    bill_to_forename: "",
    bill_to_surname: "",
    bill_to_email: "",
    bill_to_phone: "",
    bill_to_address_line1: "",
    bill_to_address_line2: "",
    bill_to_address_city: "",
    bill_to_address_state: "",
    bill_to_address_country: "LK",
    bill_to_address_postal_code: "",
    payment_method: "Visa", // Default to Visa
  });

  const { user } = useContext(AuthContext);
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    if (!user) return;
    setUserId(user.uid);
  }, [user]);

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const toggleModal = () => setModalOpen(!modalOpen);
  const togglePaymentModal = () => setPaymentModalOpen(!paymentModalOpen);

  const handleCardTypeChange = (type) => setCardType(type);
  const handleCardNumberChange = (e) => setCardNumber(e.target.value);

  const handleAddressInputChange = (e) => {
    const { name, value } = e.target;
    setNewAddress((prev) => ({ ...prev, [name]: value }));
  };

  const handlePersonalDetailsChange = (e) => {
    const { name, value } = e.target;

    // AlphaNumeric and Punctuation validation regex
    const alphaNumericPunctuationRegex = /^[a-zA-Z0-9\s.,'\-/()&]*$/;

    switch (name) {
      case "firstName":
        // Validate bill_to_forename: max 60 characters, alphanumeric and punctuation only
        if (value.length > 60) {
          setErrors((prev) => ({
            ...prev,
            firstName: "First name cannot exceed 60 characters",
          }));
          return; // Prevent input if exceeds 60 characters
        }

        if (value && !alphaNumericPunctuationRegex.test(value)) {
          setErrors((prev) => ({
            ...prev,
            firstName:
              "Only letters, numbers, spaces, and punctuation (.,'-/()&) are allowed",
          }));
          return; // Prevent input if contains invalid characters
        }

        setErrors((prev) => ({ ...prev, firstName: "" }));
        setFirstName(value);
        setBillingInfo((prev) => ({ ...prev, bill_to_forename: value }));
        break;
      case "lastName":
        // Validate bill_to_surname: max 60 characters, alphanumeric and punctuation only
        if (value.length > 60) {
          setErrors((prev) => ({
            ...prev,
            lastName: "Last name cannot exceed 60 characters",
          }));
          return; // Prevent input if exceeds 60 characters
        }

        if (value && !alphaNumericPunctuationRegex.test(value)) {
          setErrors((prev) => ({
            ...prev,
            lastName:
              "Only letters, numbers, spaces, and punctuation (.,'-/()&) are allowed",
          }));
          return; // Prevent input if contains invalid characters
        }

        setErrors((prev) => ({ ...prev, lastName: "" }));
        setLastName(value);
        setBillingInfo((prev) => ({ ...prev, bill_to_surname: value }));
        break;
      case "email":
        // Validate email: max 255 characters and valid email format
        if (value.length > 255) {
          setErrors((prev) => ({
            ...prev,
            email: "Email cannot exceed 255 characters",
          }));
          return; // Prevent input if exceeds 255 characters
        }

        // Email validation regex - allows valid email characters
        const emailRegex = /^[a-zA-Z0-9._+-@]*$/;
        if (value && !emailRegex.test(value)) {
          setErrors((prev) => ({
            ...prev,
            email: "Only letters, numbers, and .  _ + - @ are allowed in email",
          }));
          return; // Prevent input if contains invalid characters for email
        }

        // Clear error or set format error if not empty
        if (value === "") {
          setErrors((prev) => ({ ...prev, email: "" }));
        } else {
          // Check for proper email format (must have @ and domain)
          const emailFormatRegex =
            /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          if (!emailFormatRegex.test(value)) {
            setErrors((prev) => ({
              ...prev,
              email:
                "Please enter a valid email address (e.g., user@example.com)",
            }));
          } else {
            setErrors((prev) => ({ ...prev, email: "" }));
          }
        }

        setEmail(value);
        setBillingInfo((prev) => ({ ...prev, bill_to_email: value }));
        break;
      case "contactNumber":
        // Validate bill_to_phone: phone format with 6-15 characters (10 for TeleCheck)
        // Allow only digits, spaces, dashes, parentheses, and plus sign
        const phoneRegex = /^[0-9\s\-+()]*$/;

        // Check max length (15 characters for general, 10 for TeleCheck)
        const maxPhoneLength =
          billingInfo.payment_method === "TeleCheck" ? 10 : 15;
        if (value.length > maxPhoneLength) {
          setErrors((prev) => ({
            ...prev,
            contactNumber: `Phone number cannot exceed ${maxPhoneLength} characters`,
          }));
          return; // Prevent input if exceeds max length
        }

        // Check if value contains invalid characters
        if (value && !phoneRegex.test(value)) {
          setErrors((prev) => ({
            ...prev,
            contactNumber:
              "Only digits, spaces, dashes, parentheses, and + are allowed",
          }));
          return; // Prevent input if contains invalid characters
        }

        setErrors((prev) => ({ ...prev, contactNumber: "" }));
        setContactNumber(value);
        setBillingInfo((prev) => ({ ...prev, bill_to_phone: value }));
        break;
      default:
        break;
    }
  };

  const handleBillingInfoChange = (e) => {
    const { name, value } = e.target;

    // AlphaNumeric and Punctuation validation regex
    const alphaNumericPunctuationRegex = /^[a-zA-Z0-9\s.,'\-/()&]*$/;

    // Validate bill_to_address_line1 field
    if (name === "bill_to_address_line1") {
      // Determine max length based on payment method
      let maxLength;
      if (billingInfo.payment_method === "Visa") {
        maxLength = 40; // Visa Platform Connect
      } else if (billingInfo.payment_method === "Mastercard") {
        maxLength = 50; // Moneris
      } else {
        maxLength = 60; // All other processors
      }

      // Check if value exceeds max length
      if (value.length > maxLength) {
        return; // Prevent input if exceeds max length
      }

      // Check if value contains invalid characters
      if (value && !alphaNumericPunctuationRegex.test(value)) {
        return; // Prevent input if contains invalid characters
      }
    }

    // Validate bill_to_address_line2 field
    if (name === "bill_to_address_line2") {
      // Determine max length based on payment method
      let maxLength;
      if (billingInfo.payment_method === "Visa") {
        maxLength = 40; // Visa Platform Connect
      } else if (billingInfo.payment_method === "Mastercard") {
        maxLength = 50; // Moneris
      } else {
        maxLength = 60; // All other processors
      }

      // Check if value exceeds max length
      if (value.length > maxLength) {
        return; // Prevent input if exceeds max length
      }

      // Check if value contains invalid characters
      if (value && !alphaNumericPunctuationRegex.test(value)) {
        return; // Prevent input if contains invalid characters
      }
    }

    // Validate bill_to_address_city field
    if (name === "bill_to_address_city") {
      // Check if value exceeds 50 characters
      if (value.length > 50) {
        return; // Prevent input if exceeds 50 characters
      }

      // Check if value contains invalid characters
      if (value && !alphaNumericPunctuationRegex.test(value)) {
        return; // Prevent input if contains invalid characters
      }
    }

    // Validate bill_to_address_state field
    if (name === "bill_to_address_state") {
      // Check if value exceeds 30 characters
      if (value.length > 30) {
        setErrors((prev) => ({
          ...prev,
          bill_to_address_state: "State/Province cannot exceed 30 characters",
        }));
        return; // Prevent input if exceeds 30 characters
      }

      // Check if value contains invalid characters
      if (value && !alphaNumericPunctuationRegex.test(value)) {
        setErrors((prev) => ({
          ...prev,
          bill_to_address_state:
            "Only letters, numbers, spaces, and punctuation (.,'-/()&) are allowed",
        }));
        return; // Prevent input if contains invalid characters
      }

      // Clear error if validation passes
      setErrors((prev) => ({ ...prev, bill_to_address_state: "" }));
    }

    // Validate bill_to_address_postal_code field
    if (name === "bill_to_address_postal_code") {
      const country = billingInfo.bill_to_address_country;

      if (country === "US") {
        // U.S. format: 12345-6789 (5 digits, dash, 4 digits)
        const usPostalRegex = /^\d{0,5}-?\d{0,4}$/;

        if (value.length > 10) {
          return; // Prevent input if exceeds 10 characters (12345-6789)
        }

        if (value && !usPostalRegex.test(value)) {
          return; // Only allow digits and dash in correct format
        }
      } else if (country === "CA") {
        // Canada format: A1B 2C3 (letter, digit, letter, space, digit, letter, digit)
        const canadaPostalRegex = /^[A-Za-z]?\d?[A-Za-z]?\s?\d?[A-Za-z]?\d?$/;

        if (value.length > 7) {
          return; // Prevent input if exceeds 7 characters (A1B 2C3)
        }

        if (value && !canadaPostalRegex.test(value)) {
          return; // Only allow alphanumeric and space in correct format
        }
      } else {
        // For rest of the world: max 10 characters, alphanumeric and punctuation
        if (value.length > 10) {
          return; // Prevent input if exceeds 10 characters
        }

        if (value && !alphaNumericPunctuationRegex.test(value)) {
          return; // Prevent input if contains invalid characters
        }
      }
    }

    setBillingInfo((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const getProcessingPlantName = async (plantId) => {
    const plant = await getPlantByUserId(plantId);
    console.log(plant.data.companyName);
    return plant.data.companyName;
  };

  const getCourierName = async (courierId) => {
    const courier = await getCourierByUserId(courierId);
    console.log(courier);
    return courier.data.data.companyName;
  };

  const handlePaymentInputChange = (e) => {
    const { name, value } = e.target;
    console.log(`Updating ${name} with value: ${value}`);
    setNewPayment((prev) => ({ ...prev, [name]: value }));
  };
  const handleAddAddress = async () => {
    if (!newAddress.line1) {
      Swal.fire("Error", "Please fill in all required fields", "error");
      return;
    }
    const addressToAdd = { ...newAddress, id: Date.now() };
    setAddress(addressToAdd);
    try {
      await addAddressToDatabase(addressToAdd);
      Swal.fire("Success", "Address added successfully!", "success");
    } catch (error) {
      console.error("Error saving address:", error);
      Swal.fire("Error", "Failed to save address", "error");
    }
    setNewAddress({ line1: "", line2: "" });
    toggleModal();
  };

  const handleEditAddress = () => {
    setNewAddress({ line1: address.line1, line2: address.line2 });
    toggleModal();
  };

  const handleAddPayment = async () => {
    console.log(newPayment.cardNumber);
    console.log(newPayment.expiryDate);
    console.log(newPayment.cvv);
    if (!newPayment.cardNumber || !newPayment.expiryDate || !newPayment.cvv) {
      Swal.fire("Error", "Please fill in all required payment fields", "error");
      return;
    }
    const paymentToAdd = { ...newPayment, id: Date.now(), cardType };
    setPaymentDetails(paymentToAdd);
    try {
      await addPaymentToDatabase(paymentToAdd);
      Swal.fire("Success", "Payment details added successfully!", "success");
    } catch (error) {
      console.error("Error saving payment details:", error);
      Swal.fire("Error", "Failed to save payment details", "error");
    }
    setNewPayment({ cardNumber: "", expiryDate: "", cvv: "" });
    togglePaymentModal();
  };

  const handleEditPayment = () => {
    setNewPayment({
      cardNumber: paymentDetails.cardNumber,
      expiryDate: paymentDetails.expiryDate,
      cvv: paymentDetails.cvv,
    });
    togglePaymentModal();
  };

  useEffect(() => {
    const storedItems = localStorage.getItem("checkoutItems");

    console.log("Stored items:", storedItems);

    if (storedItems) {
      const parsedItems = JSON.parse(storedItems);
      console.log("Stored items2:", parsedItems[0]);

      const enrichItems = async () => {
        const enrichedItems = await Promise.all(
          parsedItems.map(async (item) => {
            try {
              const processingPlantName = await getProcessingPlantName(
                item.plantId,
              );

              console.log("Processing Plant Name:", processingPlantName);

              const courierName = await getCourierName(item.courierId);

              return {
                ...item,
                stockData: {
                  ...item.stockData,
                  Processing_Plant_Name: processingPlantName,
                  Courier_Name: courierName,
                },
              };
            } catch (error) {
              console.error("Error fetching processing plant name:", error);
              return item; // fallback to original if error occurs
            }
          }),
        );

        setItems(enrichedItems);
      };

      enrichItems();
    }
  }, []);

  const calculateTotal = () => {
    return items.reduce(
      (total, item) => total + item.stockData.Price_per_Kg * item.quantity,
      0,
    );
  };

  // Format processing methods for display (handles array or string)
  const formatProcessingMethods = (item) => {
    const val =
      item.Processing_Type ??
      item.processingType ??
      item.stockData?.Processing_Type ??
      item.stockData?.processingType ??
      null;

    if (Array.isArray(val)) return val.join(", ");
    if (typeof val === "string" && val.trim() !== "") return val;
    return "None";
  };

  const sendNotificationOutside = async (vesselNumber, formData) => {
    const vessel = vesselNumber;
    const requestNotificationPermission = async () => {
      try {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
          console.log("Notification permission granted.");
          // Get FCM token (device ID)
          const token = await getToken(messaging, {
            vapidKey:
              "BBWp8NC-KxklYuyVfI8qI0CDfjEnFgHcsTK0QUD7qYjwMI5Q1hFFS5B5WFP1N1dvv9A-APZRhQog05Nrlo_tRhM",
          });
          if (token) {
            console.log("FCM Token:", token);
            // Send the token to the server to register the device

            registerDevice(token);
            //sendNotification();
            //alert(formData.Boat_Owner_Id);
            //registerDevice(token);
            await sendNotification(
              "Order",
              "Order of " + formData.quantity + "kg placed for " + vessel,
              [
                formData.buyer_id,
                formData.Boat_Owner_Id,
                formData.Courier_id,
                formData.Processing_Plant_Id,
              ],
            );
          } else {
            console.error("No FCM token found.");
          }
        } else {
          console.log("Notification permission denied.");
        }
      } catch (error) {
        console.error("Error getting notification permission or token:", error);
      }
    };

    // Send device ID (FCM token) to your server
    const registerDevice = async (deviceId) => {
      try {
        const response = await fetch(
          "https://api.starmarketapi.online/login_firebase/register-device",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ deviceId }),
          },
        );
        const data = await response.json();
        console.log("Device registered:", data);
      } catch (error) {
        console.error("Error registering device:", error);
      }
    };

    requestNotificationPermission();

    // Listen for incoming messages (push notifications)
    const listenForMessages = () => {
      onMessage(messaging, (payload) => {
        console.log("Message received:", payload);
        // You can show a browser notification or update your UI
        if (Notification.permission === "granted") {
          new Notification(payload.notification.title, {
            body: payload.notification.body,
          });
        }
      });
    };

    listenForMessages();

    const sendNotification = async (title, body, receivers) => {
      try {
        const notificationData = {
          title: title,
          body: body,
          receivers: receivers,
        };
        // Send POST request to the server with notification data
        const response = await axios.post(
          "https://api.starmarketapi.online/notifications/send-notification",
          notificationData,
        );

        // Handle the response from the server
        console.log("Response from server:", response.data);
        //setResponseMessage("Notification sent successfully!");
      } catch (error) {
        // Handle errors
        console.error("Error sending notification:", error);
      }
    };
  };

  const submitOrder = async () => {
    // Add buyer details object
    if (!user) return;
    const buyerDetails = {
      address: address,
      firstName: firstName,
      lastName: lastName,
      email: email,
      contactNumber: contactNumber,
    };

    console.log(buyerDetails);

    const transformedData = items.map((item) => ({
      _id: item.stockData._id,
      subtractQuantity: Number(item.quantity),
      buyerDetails: buyerDetails, // Add buyerDetails to transformedData
      userId: userId,
    }));

    console.log("transformed", transformedData);

    try {
      const response = await updateAvailableQuantity(transformedData);

      const reservationIds1 = response.data.updated.map(
        (item) => item.reservationId,
        //(item) => item.reservationId
      );
      console.log("response111", reservationIds1);
      setReservationIds(reservationIds1);
      if (response.data.status === "failed") {
        Swal.fire({
          title: "Insufficient Quantity",
          text: "Some stock quantities are not available. Please adjust your order.",
          icon: "warning",
          confirmButtonText: "OK",
        });
        return;
      }
    } catch (error) {
      console.error("Error Update:", error);
      Swal.fire({
        title: "Oops!",
        text: "Something went wrong. Please try again later.",
        icon: "error",
        confirmButtonText: "OK",
        confirmButtonColor: "#d33",
      });
      return;
    }

    const generateUniqueOrderId = () =>
      `ORD-${Date.now()}-${Math.floor(Math.random() * 1000)}`;

    console.log("Orderd Items", items);

    console.log("items in orders", items);

    const orders = items.map((item) => ({
      Order_id: generateUniqueOrderId(),
      buyer_id: userId,
      stock_id: item.stockData._id,
      stock_number: item.stockData.Stock_id,
      Price_per_Kg: item.stockData.Price_per_Kg,
      Product_Name: item.stockData.Product_Name,
      Processing_Plant_Id: item.stockData.Processing_Plant_Id,
      Processing_Type: item.stockData.Processing_Type,
      Processing_Fee: item.stockData.Processing_Fee,
      Quality_Grade: item.stockData.Quality_Grade,
      Total_Available_Quantity: item.stockData.Total_Available_Quantity,
      Courier_id: item.stockData.Courier_id,
      Courier_Method: item.stockData.Courier_Method,
      Courier_Fee: 0,
      Harbour: item.stockData.Harbour,
      trip_id: item.stockData.Trip_Number,
      boat_number: item.stockData.Boat_Number,
      quantity: item.quantity,
      Boat_Owner_Id: item.stockData.Boat_Owner_Number,
      Delivery_Date: "2025-10-20",
      Payment_Status: "ToPay",
      Notes: "No",
      Discount: 0,
      Payment_Method: cardType,
      Status: "ToPay",
      deliveryAddress: address,
      paymentDetails: paymentDetails,
      buyerDetails: buyerDetails, // Add buyerDetails to orders
      Vessel_Thumb: item.stockData.Vessel_Thumb,
    }));

    try {
      const response1 = await createOrder(orders);
      console.log("response1234", response1);
      // orders.map((order, index) => {
      //   sendNotificationOutside(order.boat_number, order);
      // });

      Swal.fire({
        title: "Order Confirmed",
        text: "Your order has been successfully placed!",
        icon: "success",
        confirmButtonText: "Great!",
      });
      return response1;
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };
  const handlePayNowClick = async () => {
    // Validate all required fields before submitting
    const newErrors = {};

    // Validate firstName
    if (!firstName.trim()) {
      newErrors.firstName = "First name is required";
    }

    // Validate lastName
    if (!lastName.trim()) {
      newErrors.lastName = "Last name is required";
    }

    // Validate email
    if (!email.trim()) {
      newErrors.email = "Email is required";
    } else {
      const emailFormatRegex =
        /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailFormatRegex.test(email)) {
        newErrors.email =
          "Please enter a valid email address (e.g., user@example.com)";
      }
    }

    // Validate contactNumber
    if (!contactNumber.trim()) {
      newErrors.contactNumber = "Contact number is required";
    } else {
      const minLength = 6;
      const maxLength = billingInfo.payment_method === "TeleCheck" ? 10 : 15;
      const phoneDigitsOnly = contactNumber.replace(/[^0-9]/g, "");
      if (phoneDigitsOnly.length < minLength) {
        newErrors.contactNumber = `Phone number must have at least ${minLength} digits`;
      } else if (phoneDigitsOnly.length > maxLength) {
        newErrors.contactNumber = `Phone number cannot exceed ${maxLength} digits`;
      }
    }

    // If there are validation errors, update state and show alert
    if (Object.keys(newErrors).length > 0) {
      setErrors((prev) => ({ ...prev, ...newErrors }));
      Swal.fire({
        title: "Validation Error",
        text: "Please fill in all required fields correctly before proceeding.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    try {
      return await submitOrder();
    } catch (err) {
      console.error("Submit order failed:", err);
    }
  };

  document.title = "Order Details | StarMarket";

  console.log("items new", items);
  return (
    <React.Fragment>
      <section className="section gaps bg-light" style={{ paddingTop: "80px" }}>
        <Container>
          <Section link="Checkout" />
          <Row>
            <Col lg={8}>
              <Card>
                <CardBody>
                  <CardTitle tag="h5">Delivery Information</CardTitle>
                  <br />
                  <br />
                  <Form>
                    <div className="inpGroup">
                      <Row>
                        <div className="container-new mt-1 mb-3">
                          <div className="left">Personal Details</div>
                        </div>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <FormGroup>
                            <Input
                              type="text"
                              id="firstName"
                              name="firstName" // Add name attribute
                              placeholder="First name"
                              value={firstName} // Bind to state
                              onChange={handlePersonalDetailsChange} // Add change handler
                              invalid={!!errors.firstName}
                            />
                            {errors.firstName && (
                              <div className="text-danger small mt-1">
                                {errors.firstName}
                              </div>
                            )}
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup>
                            <Input
                              type="text"
                              id="lastName"
                              name="lastName" // Add name attribute
                              placeholder="Last name"
                              value={lastName} // Bind to state
                              onChange={handlePersonalDetailsChange} // Add change handler
                              invalid={!!errors.lastName}
                            />
                            {errors.lastName && (
                              <div className="text-danger small mt-1">
                                {errors.lastName}
                              </div>
                            )}
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <FormGroup>
                            <Input
                              type="email"
                              id="email"
                              name="email" // Add name attribute
                              placeholder="Email"
                              value={email} // Bind to state
                              onChange={handlePersonalDetailsChange} // Add change handler
                              invalid={!!errors.email}
                            />
                            {errors.email && (
                              <div className="text-danger small mt-1">
                                {errors.email}
                              </div>
                            )}
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup>
                            <Input
                              type="tel"
                              id="contactNumber" // Match id to name
                              name="contactNumber" // Add name attribute
                              placeholder="Contact Number"
                              value={contactNumber} // Bind to state
                              onChange={handlePersonalDetailsChange} // Add change handler
                              invalid={!!errors.contactNumber}
                            />
                            {errors.contactNumber && (
                              <div className="text-danger small mt-1">
                                {errors.contactNumber}
                              </div>
                            )}
                          </FormGroup>
                        </Col>
                      </Row>
                      <hr />
                      <Row>
                        <div className="container-new mt-1 mb-3">
                          <div className="left">Billing Information</div>
                        </div>
                      </Row>
                      <Row>
                        <Col md={12}>
                          <FormGroup>
                            <Label for="payment_method">Payment Method *</Label>
                            <div className="d-flex gap-3 mt-2">
                              <div
                                className={`payment-card-option ${
                                  billingInfo.payment_method === "Visa"
                                    ? "selected"
                                    : ""
                                }`}
                                onClick={() => {
                                  setBillingInfo((prev) => ({
                                    ...prev,
                                    payment_method: "Visa",
                                  }));
                                  setCardType("Visa");
                                }}
                                style={{
                                  border:
                                    billingInfo.payment_method === "Visa"
                                      ? "2px solid #007bff"
                                      : "1px solid #ddd",
                                  padding: "15px 20px",
                                  borderRadius: "8px",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                  backgroundColor:
                                    billingInfo.payment_method === "Visa"
                                      ? "#f0f8ff"
                                      : "#fff",
                                  transition: "all 0.3s",
                                }}
                              >
                                <img
                                  src={visaLogo}
                                  alt="Visa"
                                  style={{ width: "50px", height: "auto" }}
                                />
                                <span style={{ fontWeight: "500" }}>Visa</span>
                              </div>
                              <div
                                className={`payment-card-option ${
                                  billingInfo.payment_method === "Mastercard"
                                    ? "selected"
                                    : ""
                                }`}
                                onClick={() => {
                                  setBillingInfo((prev) => ({
                                    ...prev,
                                    payment_method: "Mastercard",
                                  }));
                                  setCardType("Mastercard");
                                }}
                                style={{
                                  border:
                                    billingInfo.payment_method === "Mastercard"
                                      ? "2px solid #007bff"
                                      : "1px solid #ddd",
                                  padding: "15px 20px",
                                  borderRadius: "8px",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                  backgroundColor:
                                    billingInfo.payment_method === "Mastercard"
                                      ? "#f0f8ff"
                                      : "#fff",
                                  transition: "all 0.3s",
                                }}
                              >
                                <img
                                  src={mastercardLogo}
                                  alt="Mastercard"
                                  style={{ width: "50px", height: "auto" }}
                                />
                                <span style={{ fontWeight: "500" }}>
                                  Mastercard
                                </span>
                              </div>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12}>
                          <FormGroup>
                            <Input
                              type="text"
                              id="bill_to_address_line1"
                              name="bill_to_address_line1"
                              placeholder="Billing Address Line 1 *"
                              value={billingInfo.bill_to_address_line1}
                              onChange={handleBillingInfoChange}
                              maxLength={
                                billingInfo.payment_method === "Visa"
                                  ? "40"
                                  : billingInfo.payment_method === "Mastercard"
                                    ? "50"
                                    : "60"
                              }
                            />
                            <small className="text-muted">
                              Max{" "}
                              {billingInfo.payment_method === "Visa"
                                ? "40"
                                : billingInfo.payment_method === "Mastercard"
                                  ? "50"
                                  : "60"}{" "}
                              characters for {billingInfo.payment_method}.
                              Letters, numbers, and punctuation only.
                            </small>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12}>
                          <FormGroup>
                            <Input
                              type="text"
                              id="bill_to_address_line2"
                              name="bill_to_address_line2"
                              placeholder="Billing Address Line 2 (Optional)"
                              value={billingInfo.bill_to_address_line2}
                              onChange={handleBillingInfoChange}
                              maxLength={
                                billingInfo.payment_method === "Visa"
                                  ? "40"
                                  : billingInfo.payment_method === "Mastercard"
                                    ? "50"
                                    : "60"
                              }
                            />
                            <small className="text-muted">
                              Max{" "}
                              {billingInfo.payment_method === "Visa"
                                ? "40"
                                : billingInfo.payment_method === "Mastercard"
                                  ? "50"
                                  : "60"}{" "}
                              characters for {billingInfo.payment_method}.
                              Letters, numbers, and punctuation only.
                            </small>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <FormGroup>
                            <Input
                              type="text"
                              id="bill_to_address_city"
                              name="bill_to_address_city"
                              placeholder="City *"
                              value={billingInfo.bill_to_address_city}
                              onChange={handleBillingInfoChange}
                              maxLength="50"
                            />
                            <small className="text-muted">
                              Max 50 characters. Letters, numbers, and
                              punctuation only.
                            </small>
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup>
                            <Input
                              type="text"
                              id="bill_to_address_state"
                              name="bill_to_address_state"
                              placeholder="State/Province"
                              value={billingInfo.bill_to_address_state}
                              onChange={handleBillingInfoChange}
                              invalid={!!errors.bill_to_address_state}
                            />
                            {errors.bill_to_address_state && (
                              <div className="text-danger small mt-1">
                                {errors.bill_to_address_state}
                              </div>
                            )}
                            <small className="text-muted">
                              Max 30 characters. Letters, numbers, and
                              punctuation only.
                            </small>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <FormGroup>
                            <Input
                              type="text"
                              id="bill_to_address_postal_code"
                              name="bill_to_address_postal_code"
                              placeholder={
                                billingInfo.bill_to_address_country === "US"
                                  ? "Postal Code * (e.g., 12345-6789)"
                                  : billingInfo.bill_to_address_country === "CA"
                                    ? "Postal Code * (e.g., A1B 2C3)"
                                    : "Postal Code *"
                              }
                              value={billingInfo.bill_to_address_postal_code}
                              onChange={handleBillingInfoChange}
                              maxLength={
                                billingInfo.bill_to_address_country === "US"
                                  ? "10"
                                  : billingInfo.bill_to_address_country === "CA"
                                    ? "7"
                                    : "10"
                              }
                            />
                            <small className="text-muted">
                              {billingInfo.bill_to_address_country === "US" &&
                                "Format: 12345-6789 (Required)"}
                              {billingInfo.bill_to_address_country === "CA" &&
                                "Format: A1B 2C3 (Required)"}
                              {billingInfo.bill_to_address_country !== "US" &&
                                billingInfo.bill_to_address_country !== "CA" &&
                                "Max 10 characters"}
                            </small>
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup>
                            <Input
                              type="select"
                              id="bill_to_address_country"
                              name="bill_to_address_country"
                              value={billingInfo.bill_to_address_country}
                              onChange={handleBillingInfoChange}
                            >
                              <option value="LK">Sri Lanka</option>
                              <option value="US">United States</option>
                              <option value="GB">United Kingdom</option>
                              <option value="IN">India</option>
                              <option value="AU">Australia</option>
                              <option value="CA">Canada</option>
                            </Input>
                          </FormGroup>
                        </Col>
                      </Row>
                      <hr />
                      {/* <Row>
                        <div className="container-new mt-3 mb-3">
                          <div className="left">Payment Details</div>
                        </div>
                      </Row> */}
                      {/* {paymentDetails ? (
                        <Row className="p-3">
                          <div
                            className="address"
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              width: '100%',
                            }}
                          >
                            <div style={{ display: 'flex' }}>
                              <i className="uil uil-credit-card"></i>
                              <div>
                                <div>{paymentDetails.cardType}</div>
                                <div>
                                  xxxx xxxx xxxx{' '}
                                  {paymentDetails.cardNumber.slice(-4)}
                                </div>
                              </div>
                            </div>

                            <span
                              onClick={handleEditPayment}
                              style={{
                                marginTop: '15px',
                                marginRight: '15px',
                                cursor: 'pointer',
                              }}
                            >
                              Edit
                            </span>
                          </div>
                        </Row>
                      ) : (
                        <Row
                          onClick={togglePaymentModal}
                          className="p-3 d-flex justify-content-center align-items-center"
                        >
                          <div
                            style={{
                              cursor: 'pointer',
                              display: 'inline-block',
                              border: '1px dashed #000',
                              padding: '5px 10px',
                              borderRadius: '5px',
                            }}
                            className="payment d-flex justify-content-center align-items-center"
                          >
                            <span className="right">
                              + Add Payment Details
                            </span>
                          </div>
                        </Row>
                      )} */}
                    </div>
                  </Form>
                </CardBody>
              </Card>

              {/* Address Modal */}
              <Modal isOpen={modalOpen} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>
                  {address ? "Edit Address" : "Add New Address"}
                </ModalHeader>
                <ModalBody>
                  <Form>
                    <FormGroup>
                      <Label for="line1">Address Line 1</Label>
                      <Input
                        type="text"
                        name="line1"
                        id="line1"
                        value={newAddress.line1}
                        onChange={handleAddressInputChange}
                        placeholder="Enter address line 1"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label for="line2">Address Line 2 (Optional)</Label>
                      <Input
                        type="text"
                        name="line2"
                        id="line2"
                        value={newAddress.line2}
                        onChange={handleAddressInputChange}
                        placeholder="Enter address line 2"
                      />
                    </FormGroup>
                  </Form>
                </ModalBody>
                <ModalFooter>
                  <Button color="primary" onClick={handleAddAddress}>
                    {address ? "Update Address" : "Add Address"}
                  </Button>{" "}
                  <Button color="secondary" onClick={toggleModal}>
                    Cancel
                  </Button>
                </ModalFooter>
              </Modal>

              {/* Payment Modal */}
              <Modal isOpen={paymentModalOpen} toggle={togglePaymentModal}>
                <ModalHeader toggle={togglePaymentModal}>
                  {paymentDetails
                    ? "Edit Payment Details"
                    : "Add Payment Details"}
                </ModalHeader>
                <ModalBody>
                  <Form>
                    <FormGroup>
                      <Label style={{ color: "#666", fontSize: "14px" }}>
                        Pay with
                      </Label>
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          marginTop: "10px",
                        }}
                      >
                        <img
                          src={visaLogo}
                          alt="Visa"
                          style={{
                            width: "50px",
                            height: "30px",
                            border: "1px solid #ddd",
                            borderRadius: "5px",
                            padding: "1px",
                          }}
                        />
                        <img
                          src={mastercardLogo}
                          alt="MasterCard"
                          style={{
                            width: "50px",
                            height: "30px",
                            border: "1px solid #ddd",
                            borderRadius: "5px",
                            padding: "1px",
                          }}
                        />
                      </div>
                    </FormGroup>
                    <FormGroup>
                      <Label style={{ color: "#666", fontSize: "14px" }}>
                        Card number
                      </Label>
                      <Input
                        type="text"
                        name="cardNumber"
                        id="cardNumber"
                        value={newPayment.cardNumber}
                        onChange={handlePaymentInputChange}
                        placeholder="1234 5678 9012 3456"
                        maxLength="19"
                        style={{
                          borderRadius: "8px",
                          border: "1px solid #ddd",
                          padding: "10px",
                          fontSize: "16px",
                        }}
                      />
                    </FormGroup>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label style={{ color: "#666", fontSize: "14px" }}>
                            Exp Date
                          </Label>
                          <Input
                            type="text"
                            name="expiryDate"
                            id="expiryDate"
                            value={newPayment.expiryDate}
                            onChange={handlePaymentInputChange}
                            placeholder="MM/YY"
                            maxLength="5"
                            style={{
                              borderRadius: "8px",
                              border: "1px solid #ddd",
                              padding: "10px",
                              fontSize: "16px",
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label style={{ color: "#666", fontSize: "14px" }}>
                            CVV2
                          </Label>
                          <Input
                            type="text"
                            name="cvv"
                            id="cvv"
                            value={newPayment.cvv} // Ensure this is bound to newPayment.cvv
                            onChange={handlePaymentInputChange}
                            placeholder="123"
                            maxLength="3"
                            style={{
                              borderRadius: "8px",
                              border: "1px solid #ddd",
                              padding: "10px",
                              fontSize: "16px",
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                </ModalBody>
                <ModalFooter style={{ borderTop: "none", paddingTop: "0" }}>
                  <Button
                    style={{
                      backgroundColor: "#6f42c1",
                      border: "none",
                      borderRadius: "25px",
                      padding: "10px 20px",
                      width: "100%",
                      fontSize: "16px",
                      fontWeight: "bold",
                    }}
                    onClick={handleAddPayment}
                  >
                    Pay {calculateTotal()} LKR
                  </Button>
                </ModalFooter>
              </Modal>

              {items.map((item, index) => (
                <div key={item._id} className="list-item mb-3">
                  <div style={{ width: "100%" }} className="card list-card">
                    <div
                      className="card-header"
                      style={{ borderRadius: "20px" }}
                    >
                      <span
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "800",
                          borderRadius: "20px",
                        }}
                      >
                        Package {index + 1} of {items.length}
                      </span>
                    </div>
                    <div className="overlay-boat list-card-body card-body">
                      <div className="d-flex align-items-start">
                        <div
                          style={{
                            position: "relative",
                            width: "225px",
                            height: "150px",
                          }}
                        >
                          <img
                            src={
                              item.stockData.Vessel_Thumb || item.Vessel_Thumb
                            }
                            alt="Product"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                        <div className="card-body-content flex-grow-1">
                          <div className="d-flex justifyContent-between align-items-start">
                            <div>
                              <span
                                style={{
                                  fontSize: "1.1rem",
                                  fontWeight: "800",
                                }}
                              >
                                {item.stockData.Product_Name}
                              </span>
                              <br />
                              <span
                                style={{
                                  fontSize: "1rem",
                                  color: "#00d4ff",
                                  fontWeight: "800",
                                }}
                              >
                                {item.stockData.Price_per_Kg * item.quantity}{" "}
                                LKR
                              </span>
                              <br />
                              <span>
                                {item.stockData.Harbour} |{" "}
                                {item.stockData.Boat_Number}
                              </span>
                              <br />
                              <br />
                            </div>
                            <div className="d-flex align-items-center p-2">
                              <h5>{item.quantity} KG</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="card-footer"
                      style={{ borderRadius: "20px" }}
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <div
                            style={{
                              fontSize: "1.0rem",
                              fontWeight: "500",

                              borderRadius: "10px",
                              padding: "10px",
                            }}
                          >
                            <h5 className="text-muted">Processing Details</h5>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "2px",
                              }}
                            >
                              <span style={{ fontWeight: "800" }}>
                                Processing Plant:
                              </span>
                              <span>
                                {item.stockData.Processing_Plant_Name}
                              </span>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "2px",
                              }}
                            >
                              <span style={{ fontWeight: "800" }}>
                                Processing Method:
                              </span>
                              <span>{formatProcessingMethods(item)}</span>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <span style={{ fontWeight: "800" }}>
                                Processing Fee:
                              </span>
                              <span>{item.Processing_Fee}LKR (Per Kg)</span>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div
                            style={{
                              fontSize: "1.0rem",
                              fontWeight: "500",

                              borderRadius: "10px",
                              padding: "10px",
                            }}
                          >
                            <h5 className="text-muted">Courier Details</h5>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "2px",
                              }}
                            >
                              <span style={{ fontWeight: "800" }}>
                                Courier:
                              </span>
                              <span>{item.stockData.Courier_Name}</span>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "2px",
                              }}
                            >
                              <span style={{ fontWeight: "800" }}>
                                Courier Method:
                              </span>
                              <span>{item.stockData.Courier_Method}</span>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <span style={{ fontWeight: "800" }}>
                                Courier Fee:
                              </span>
                              <span>{item.stockData.Courier_Fee}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              <br />
            </Col>
            <Col lg={4} className="mt-4 mt-lg-0">
              <RightSideContent2
                Items={items}
                handlePayNowClick={handlePayNowClick}
                address={address}
                paymentDetails={paymentDetails}
                toggleModal={toggleModal}
                togglePaymentModal={togglePaymentModal}
                handleEditAddress={handleEditAddress}
                handleEditPayment={handleEditPayment}
                calculateTotal={calculateTotal}
                firstName={firstName}
                lastName={lastName}
                email={email}
                contactNumber={contactNumber}
                handlePersonalDetailsChange={handlePersonalDetailsChange}
                reservationIds={reservationIds}
                billingInfo={billingInfo}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Checkout;
